export default "__VITE_ASSET__D5uMp0V2__"